export default __webpack_public_path__ + "static/media/product-image-10.fae443c6.jpg";